import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import useRequest from '@/utils/useRequest';
import styles from './index.module.scss';
import { DateRangeFormatter } from '@/utils/useDate';
import { useRouter } from 'next/router';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const [data, setData] = useState<any>({})
  const request = useRequest()
  const router = useRouter()
  const month = {
    '01': '一',
    '02': '二',
    '03': '三',
    '04': '四',
    '05': '五',
    '06': '六',
    '07': '七',
    '08': '八',
    '09': '九',
    '10': '十',
    '11': '十一',
    '12': '十二',
  } as any

  const groupAndSortEvents = (events: any) => {
    const result = {} as any;

    // 1. 按日期和地点分组
    events.forEach((event: any) => {
      const date = event.date_start_en.substring(0, 10); // 提取日期部分
      const location = event.location_en;

      if (!result[date]) {
        result[date] = {};
      }

      if (!result[date][location]) {
        result[date][location] = [];
      }

      result[date][location].push(event);
    });

    // 2. 对每组内按时间排序
    for (const date in result) {
      for (const location in result[date]) {
        result[date][location].sort((a: any, b: any) =>
          a.date_start_en.localeCompare(b.date_start_en)
        );
      }
    }

    return result;
  }

  const getData = useCallback(async () => {
    const { data } = await request.get(`/home/get_event_list`, {
      params: {
        category_id: 3,
        rows: 999
      }
    })
    setData(groupAndSortEvents(data.data?.list || []))
    console.log(groupAndSortEvents(data.data?.list || []));

  }, [])

  useEffect(() => {
    getData()
  }, [])
  return (
    <PageLayout
      banner='/image/event-banner.png'
    >
      <div className={styles.container}>
        {getHead(navDetail)}
        <h2>会议论坛</h2>
        {
          Object.keys(data)?.reverse()?.map((item: any) => (
            <div key={item}>
              <h3>
                <span>时间</span>
                <span className={styles.line}>/</span>
                <p>
                  <span style={{ color: '#1447c1' }}>{month[item?.split('-')?.[1]]}</span>
                  <span style={{ color: "#14c7b8" }}>月</span>
                  <span style={{ color: "#01c773" }}>{item?.split('-')?.[2]}</span></p>
              </h3>
              {
                Object.keys(data[item])?.reverse().map((child: any) => (
                  <div className="itemBox" key={child}>
                    <h4>{child}</h4>
                    <ul>
                      {
                        data[item][child]?.map((event: any) => (
                          <li key={event.id}>
                            <a href={`/event/forum/detail?id=${event.id}`}>
                              <span className={styles.time}>{event.date_start_en.slice(11, 16)}-{event.date_end_en.slice(11, 16)}</span>
                              <span>{event.title_en}</span>
                            </a>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
    </PageLayout>

  );
};


